import { queryOptions } from '@tanstack/react-query';
import { service } from '@maia/broker';

export function GetBrokers() {
  return queryOptions({
    queryKey: ['broker', 'get-brokers'],
    queryFn: () => service.getAll(),
  });
}
